import React from 'react'
import MainComponentWrapper from '../../Common/MainComponentWrapper'
import Event from './Event'

const SearchEvents = ({ loading, error, eventList }) => {
    return (
        <MainComponentWrapper Loading={loading} errorInfo={error}>

            {
                <div className='row mx-1'>
                    {eventList?.map(({ _id, title, eventTiming, category, location, mainimage, wishlist }, index) => {
                        return <Event key={index} title={title} eventTiming={eventTiming} category={category} location={location} Id={_id} mainimage={mainimage} wishlist={wishlist} />
                    })}
                </div>
            }
        </MainComponentWrapper>
    )
}

export default SearchEvents